export default __webpack_public_path__ + "cf9e8f27cea5183592f4a325e9cefbeb.png";